import { render, staticRenderFns } from "./ggDropdownItem.vue?vue&type=template&id=4a303c72&scoped=true"
import script from "./ggDropdownItem.vue?vue&type=script&lang=js"
export * from "./ggDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a303c72",
  null
  
)

export default component.exports